<template>
  <v-container fluid>
    <v-checkbox
        dense
        v-bind="$attrs"
        v-model="innerValue"
        @change="onChange"
        color="green darken-4"
        on-icon="mdi-delete-restore"
        off-icon="mdi-delete-outline"
    ></v-checkbox>
  </v-container>
</template>

<script>

export default {
  name: 'BaseDeletedCheckBox',
  // inheritAttrs: false,
  props: ['value'],
  data() {
    return {
      innerValue: this.value,
    }
  },

  components: {},

  computed: {
    color() {
      console.log('color', this.innerValue)
      if (this.innerValue === false)
        return 'red darken-4'
      return 'green darken-4'
    }
  },

  methods: {
    onChange(event) {
      console.log('onChange', this.innerValue)
      this.$emit('update:value', this.innerValue)
      this.$emit('change', this.innerValue)
    },
  },

  mounted() {
  },

}
</script>

<style scoped lang="scss">

</style>